// Frontend mirror of backend routes_cart._auto_final_price / _variant_carton_cbm so the
// PRICE column and Final Price default reflect the same customer-coefficient + inland
// freight formula the backend applies when persisting `final_price`.

export function variantCartonCbm(v = {}) {
  const l = Number(v.length_cm) || 0;
  const w = Number(v.width_cm) || 0;
  const h = Number(v.height_cm) || 0;
  return (l * w * h) / 1_000_000;
}

export function autoFinalPrice(price, coefficient, pricePerSkid, cartonCbm, packingQty) {
  const basePrice = Number(price) || 0;
  const coef = Number(coefficient) || 1;
  const skid = Number(pricePerSkid) || 0;
  const pack = Number(packingQty) || 0;
  const freightPerPiece = skid > 0 && pack > 0 ? (skid * cartonCbm) / 1.7 / pack : 0;
  return Math.round((basePrice + freightPerPiece) * coef * 100) / 100;
}

export function variantAutoPrice(v, coefficient, pricePerSkid = 0) {
  return autoFinalPrice(v?.price, coefficient, pricePerSkid, variantCartonCbm(v), v?.packing_qty);
}
